import { render, staticRenderFns } from "./ProductsBlock.vue?vue&type=template&id=58b10ee8&scoped=true"
import script from "./ProductsBlock.vue?vue&type=script&lang=js"
export * from "./ProductsBlock.vue?vue&type=script&lang=js"
import style0 from "./ProductsBlock.vue?vue&type=style&index=0&id=58b10ee8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b10ee8",
  null
  
)

export default component.exports